import React from 'react';
import { MediaRecognition } from '../MediaRecognition/MediaRecognition';
import { Container } from '@/components/Containers/Container';
import MenuSection from './MenuSection';
import DescriptionWithIconsSection from './DescriptionWithIconsSection';
import BottomSection from './BottomSection';
import Image from 'next/image';
import Socials from '@/components/Footer/Socials';

export default function Footer() {
  return (
    <>
      <footer className="containerFooter overflow-hidden relative z-10">
        <MediaRecognition isDark={true} />
        <Container padding="p-0 relative">
          <div className="flex flex-col lg:gap-12 gap-8">
            <div className="flex gap-10 max-lg:flex-col-reverse">
              <MenuSection />
              <DescriptionWithIconsSection />
            </div>
            <div className="lg:hidden">
              <Socials />
            </div>
            <BottomSection />
            <a
              className="lg:absolute lg:right-0 lg:bottom-0 flex items-center justify-center"
              href="https://www.aitechsuite.com/tools/20776?ref=featured&v=98"
              target="_blank"
              rel="nofollow noreferrer"
            >
              <Image
                alt="aits-icon"
                src="/img/footer-aits-icon-light.webp"
                width="125"
                height="87"
              />
            </a>
          </div>
        </Container>
      </footer>
    </>
  );
}
